import { Routes } from '@angular/router';
import { Home } from './pages/home/home';
import { Dashboard } from './pages/dashboard/dashboard';
import { Profile } from './pages/profile/profile';
import { Draft } from './pages/draft/draft';
import { Join } from './pages/join/join';
import { authGuard } from './guards/auth-guard';

export const routes: Routes = [
  { path: '', component: Home },
  { path: 'leagues', component: Dashboard, canActivate: [authGuard] },
  { path: 'collection', component: Profile, canActivate: [authGuard] },
  { path: 'd/:leagueIdHash', component: Draft, canActivate: [authGuard] },
  { path: 'join/:hash', component: Join, canActivate: [authGuard] },
  { path: '**', redirectTo: '' }
];
